import View from './View'

const Container = ({register}) => 


<View title="Cadastro Cobranca" register={register}/>

export default Container
